export default function file() {
  $('.wp-block-file').each(function () {
    $(this).find('a').first().addClass('wp-block-file__link');

    $(this).find('a').addClass('btn-wavy-hover').wrap('<div class="wp-block-file__btn-wrapper">');

    $(this).find('.wp-block-file__button').addClass('no-ajaxify');
  });
}
